import React, { useCallback, useEffect, useRef, useState } from 'react';
import MessagesTab from '../../../components/MessageTab/MessageTab';
import { useDispatch, useSelector } from 'react-redux';

import {
  reviewsForTopic,
  reviewsForCreatedTopic,
  reviewsFilterTopic,
  reviewsFilterTopicPreview,
  reviewsForDownload,
  searchPost,
  searchPostPreview,
  searchTextFunc,
  reviewsForSinglePost,
  reviewsForSingleComment,
} from '../../../store/redux/slices/topicSlice';
import styled from 'styled-components';
import {
  BackArrow,
  FacebookLogo,
  InstagramIconSmall,
  NewsLogo,
  SearchIcon,
  X_icon,
  YouTubeRedIcon,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import Button from '../../../Common/Button/Button';
import { formatDateFilter, formatDateFilter2 } from '../../../utils';
import MyDatePicker from '../../../components/DatePicker/DatePicker';
import Lottie from 'lottie-react';
import Loader from '../../../assests/animation/Loader2.json';
import { debounce } from 'lodash';
import FilterPanelPost from '../../../components/FilterPanelPost/FilterPanelPost';

const Wrapper = styled.div`
  width: 96%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-bottom: 85px;
`;
const LoaderDiv = styled.div`

& > div {
height:250px;
}
`;
const LogoImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 8px 0px #a2a2a23d;
  border: 1px solid #d9d9d9;
  width: 43px;
  height: 42px;
  border-radius: 5px;
  & svg {
    width: 20px;
    height: 20px;
    padding-top: 5px;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  gap: 30px;
  font-size: 15px;
  font-weight: 600;
  padding: 30px 0px;
`;
const ContainerWithoutPadding = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  gap: 30px;
  font-size: 15px;
  color: #2a2929;

  font-weight: 600;
  padding: 0px 0px 30px 0px;
`;
const StyledInput = styled.input`
  min-width: 375px;
  min-height: 30px;
  width: 440px;
  padding-right: 35px;
  border: 1px solid #ccc;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: green;
  }
`;
const ContainerInput = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;

  & input {
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    font-family: inherit;
    font-size: 15px;
    font-weight: 400;
    color: #636363;

    padding: 5px 10px;
    border-radius: 5px;
  }
`;
const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

function ReviewsTab({
  resetFlag = false,
  download,
  showReport,
  startDate = '',
  endDate = '',
  preview_uuid = '',
  job_id,
  email_id,
  filteredReviews,
  channel,
  is_comment=0,
  min = '',
  max = '',
  hideDropdown,
  formatValue = 'dd-MM-yyyy',
  search_type = '',
  is_single_post = false,
  apiVal = []
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [firstDate, setFirstDate] = useState(startDate);
  const [lastDate, setLastDate] = useState(endDate);
  const [firstTime, setFirstTime] = useState('');
  const [lastTime, setLastTime] = useState('');
  const [filterData, setFilteredData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const tableRef = useRef(null); // ✅ ref for scroll
  // const dateHandler = (e) => {
  //   const { name, value } = e;
  //   console.log(value, 'value');
  //   const formatDate = (isoString) => {
  //     const date = new Date(isoString); // Create a Date object from the ISO string
  //     const year = date.getFullYear(); // Get the year
  //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Get the month (0-based index, hence +1)
  //     const day = String(date.getDate()).padStart(2, '0'); // Get the day

  //     return `${year}-${month}-${day}`; // Return the formatted date
  //   };

  //   const formattedDate = formatDate(value);

  //   if (name === 'firstPostDate' && value) {
  //     // const [year, month, day] = value?.split('-');
  //     setFirstDate(formattedDate);
  //   } else if (name === 'lastPostDateReview' && value) {
  //     // const [year, month, day] = value?.split('-');
  //     setLastDate(formattedDate);
  //   }
  // };

  // const timeHandler = (e) => {
  //   const { name, value } = e.target;
  //   if (name === 'firstPostTime') {
  //     setFirstTime(value);
  //   } else if (name === 'lastPostTime') {
  //     setLastTime(value);
  //   }
  // };

  // const handleSave = () => {
  //   setLoading(true);
  //   const isValidDate = (date) => {
  //     return date instanceof Date && !isNaN(date.getTime());
  //   };

  //   const validateDate = (date) => {
  //     // Convert date strings to Date objects
  //     const start = new Date(min); // Explicitly parse the initialStartDate
  //     const end = new Date(max); // Explicitly parse the initialEndDate
  //     const datedate = new Date(date); // Explicitly parse the date to be validated

  //     if (!isValidDate(start) || !isValidDate(end) || !isValidDate(datedate))
  //       return false;

  //     const isAfterMin = datedate >= start;
  //     const isBeforeMax = datedate <= end;

  //     // console.log("Start Date Range:", start);
  //     // console.log("End Date Range:", end);
  //     // console.log("Date Being Validated:", datedate);

  //     return isAfterMin && isBeforeMax;
  //   };

  //   if (validateDate(firstDate) && validateDate(lastDate)) {
  //     const dates = {
  //       start_date: firstDate,
  //       end_date: lastDate,
  //     };
  //     dispatch(
  //       preview_uuid
  //         ? reviewsFilterTopicPreview({ dates, preview_uuid })
  //         : reviewsFilterTopic({ dates, job_id })
  //     )
  //       .then((res) => {
  //         setFilteredData(res.payload.data.reviews);
  //         setLoading(false);
  //         // setFilter(true)
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.error('Error:', error); // Handling any errors
  //       });
  //   } else {
  //     alert(`Enter valid Input between ${min} and ${max}`);
  //   }
  // };
  const { reviewsForTopicData, searchVal, searchText } =
    useSelector((state) => state.topicBuilder) || null;

  useEffect(() => {
    setFirstDate(startDate);
    setFilteredData(null);
  }, [startDate, job_id]);
  useEffect(() => {
    setFilteredData(null);
    setLastDate(endDate);
  }, [endDate, job_id]);
  const childRef = useRef();
  const [isFilterEd, setIsFiltered] = useState(false);
  const prevJobIdRef = useRef();
  const [reset, setReset] = useState(0);
  useEffect(() => {

    if (!job_id) return;

    // Only run if job_id actually changed
    if (prevJobIdRef.current !== job_id) {
      setIsFiltered(false);

      prevJobIdRef.current = job_id;
    }
    const currentJobIdStr = JSON.stringify(job_id);

    if (
      JSON.stringify(prevJobIdRef.current) !== currentJobIdStr ||
      prevJobIdRef.current === undefined
    ) {
      // console.log(JSON.stringify(prevJobIdRef.current), currentJobIdStr);
      setReset(Date.now());
      prevJobIdRef.current = JSON.stringify(job_id);
    }
    if (tableRef.current) {
      tableRef.current.scrollTop = 0;
    }

    if (
      childRef.current &&
      typeof childRef.current.handleClear === 'function'
    ) {
      childRef.current.handleClear(false);
    }

    setLoading(true);
    if(is_comment == '1'){
      console.log("============val================", apiVal?.[0]);
      dispatch(reviewsForSingleComment(apiVal?.[0]));
      setLoading(false);

    }else if (is_single_post == true && apiVal?.length > 0) {
      console.log("============val================", apiVal?.[0]);

      dispatch(reviewsForSinglePost(apiVal?.[0]));
      setLoading(false);
    } else if (download || showReport) {
      console.log("============val 2================",download || showReport);
      dispatch(reviewsForDownload({ job_id, email_id }));
      setLoading(false);
    } else if (job_id && reviewsForTopicData === null && filteredReviews) {
      console.log("============val 3================",job_id && reviewsForTopicData === null && filteredReviews);
      const dates = {
        date_from: formatDateFilter2(startDate),
        date_to: formatDateFilter2(endDate),
      };
      dispatch(reviewsFilterTopic({ 'filterPayload':dates, job_id }));
      setLoading(false);
    } else if (preview_uuid) {
      console.log("============val 4================",preview_uuid);
      
      dispatch(reviewsForTopic(preview_uuid));
      setLoading(false);
    } else if (startDate && endDate && job_id) {
      console.log("============val 5================",job_id);
      const dates = {
        date_from: formatDateFilter2(startDate),
        date_to: formatDateFilter2(endDate),
      };
      console.log(dates,"dates");
      
      dispatch(reviewsFilterTopic({ 'filterPayload' : dates, job_id }));
      // dispatch(reviewsForCreatedTopic(job_id));
      setLoading(false);
    }else if (job_id) {
      console.log("============val 5================",job_id);
      dispatch(reviewsForCreatedTopic(job_id));
      setLoading(false);
    }
  }, [job_id,startDate,endDate]);

  // const formatDateFilterForDisplay = (dateString) => {
  //   if (dateString) {
  //     const [day, month, year] = dateString.split('/');
  //     const date = new Date(year, month - 1, day);
  //     const Cyear = date.getFullYear();
  //     const Cmonth = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based

  //     const Cday = String(date.getDate()).padStart(2, '0');
  //     // console.log(date,year, month - 1, day, "month",`${Cyear}-${Cmonth}-${Cday}`);
  //     return `${Cyear}-${Cmonth}-${Cday}`; // Returns YYYY-MM-DD
  //   } else {
  //     return '';
  //   }
  // };
  // const debouncedSearch = useCallback(
  //   debounce((value, val_job) => {
  //     dispatch(searchPost({ keyword: value, job_id: val_job }))
  //       .then((res) => {
  //         setFilteredData(res.payload?.data?.reviews); // Assuming reviews are part of the response
  //       })
  //       .catch((error) => {
  //         console.error('Error:', error);
  //       });
  //   }, 500), // Debounce delay (500ms)
  //   [] // Empty dependency array means this function is created only once
  // );
  // const debouncedSearchPreview = useCallback(
  //   debounce((value, pre) => {
  //     dispatch(searchPostPreview({ keyword: value, job_id: pre }))
  //       .then((res) => {
  //         setFilteredData(res.payload?.data?.reviews); // Assuming reviews are part of the response
  //       })
  //       .catch((error) => {
  //         console.error('Error:', error);
  //       });
  //   }, 500), // Debounce delay (500ms)
  //   [] // Empty dependency array means this function is created only once
  // );

  return (
    <ContainerWrapper>
      <ContainerWithoutPadding style={{ justifyContent: 'end' }}>
        <ContainerInput>
          <div>
            {/* <input
                type="date"
                name="lastPostDate"
                // value={lastDate}
                value={lastDate ? formatDateFilterForDisplay(lastDate) : ''} // Ensure value is in YYYY-MM-DD format

                min={min ? formatDateFilterForDisplay(min) : ''}
                max={max ? formatDateFilterForDisplay(max) : ''}
                onChange={dateHandler}
              /> */}
            {/* <input
                  width='100px'
                  name='lastPostDateReview'
                  value={searchText}
                  style={{
                    minWidth: '375px',
                    minHeight: '30px',
                    width: '440px',
                    paddingRight: '35px',
                  }}
                  placeholder='Search by posts or profile'
                  onChange={(e) => handleChangeVal(e.target.value)}
                /> */}
            {/* <StyledInput
                  name='lastPostDateReview'
                  value={searchText}
                  placeholder='Search by posts or profile'
                  onChange={(e) => handleChangeVal(e.target.value)}
                /> */}

            {
              is_single_post == true ? <></>
                :
                <FilterPanelPost
                  channel={channel}
                  lastDate={lastDate}
                  startDate={firstDate}
                  ref={childRef}
                  manualResetTrigger={reset}
                  setFilteredData={(filterData) => {
                    setFilteredData(filterData);
                  }}
                  isFilterEd={isFilterEd}
                  setIsFiltered={(data) => setIsFiltered(data)}
                  setCurrentPage={setCurrentPage}
                  preview_uuid={preview_uuid}
                  setLoading={(data) => setLoading(data)}
                  job_id={job_id}
                />}

            {/* <span
                  style={{ position: 'relative', right: '28px', top: '3px' }}
                >
                  {SearchIcon}
                </span> */}
          </div>
          {/* {
            channel === 'twitter' &&
            <div>
              <div>Time:</div>
              <input
                type="time"
                name="lastPostTime"
                value={lastTime}
                onChange={timeHandler}
              />
            </div>
          } */}
        </ContainerInput>
      </ContainerWithoutPadding>
      <Wrapper
        ref={tableRef}
        style={{
          scrollBehavior: 'smooth',
          maxHeight: '600px',
          overflowY: 'auto',
        }}
      >
        {(resetFlag === true && filteredReviews === undefined) ||
          loading == true ? (
          <LoaderDiv >
            <Lottie
              data-testid='loader'
              animationData={Loader}
              loop={true}
              width='100px'
              height='100px'
            />
          </LoaderDiv>
        ) : (
          <MessagesTab
            tableRef={tableRef}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            job_id={job_id}
            preview_uuid={preview_uuid}
            infoVal={
              channel == 'youtube' ?
                'Details of viewer comments across YouTube videos and Shorts.'
                :
                channel == 'instagram' && search_type == 'hashtag'
                  ? 'Review a detailed list of all posts within the specified time period, including post content, links to the post page, user profile, and engagement metrics such as likes , comments and views. '
                  : channel == 'instagram'
                    ? 'Review a detailed list of all posts within the specified time period, including post content, links to the post page and engagement metrics such as likes, comments and views.'
                    : channel == 'twitter'
                      ? 'Review a detailed list of all posts within the specified time period, including post content, links to the post page, user profile, and engagement metrics such as likes, replies, and views.'
                      : 'Review a detailed list of all posts within the specified time period, including post content, links to the post page, user profile, and engagement metrics such as likes and comments.'
            }
            isNews={channel === 'news' ? true : false}
            download={download}
            graphStyles={{
              gridTemplateColumns:
                channel === 'news'
                  ? '1fr 50% 1fr'
                  : channel === 'twitter'
                    ? '45% 1fr 1fr 1fr 1fr 1fr'
                    : channel === 'instagram' && search_type == 'hashtag'
                      ? '45% 1fr 1fr 1fr 1fr'
                      : channel === 'youtube'
                        ? '45% 1fr 1fr 1fr 1fr'
                        : channel === 'facebook'
                          ? '45% 1fr 1fr 1fr 1fr'
                          : '45% 1fr 1fr 1fr',
            }}
            reviews={filterData ? filterData : reviewsForTopicData || []}
            filterCol={
              channel === 'youtube'
                ? [2, 3, 4, 5]
                : channel === 'facebook'
                  ? [2, 3, 4, 5]
                  : channel === 'twitter'
                    ? [2, 3, 4, 5, 6]
                    : channel === 'instagram' && search_type == 'hashtag'
                      ? [2, 3, 4, 5]
                      : [2, 3, 4]
            }
            // startDate={startDate}
            // endDate={endDate}
            columns={
              channel === 'news'
                ? ['News Source', 'Posts', 'Posted on']
                : channel === 'youtube'
                  ? ['Posts', 'Profile', 'Likes', 'Comments', 'Views']
                  : channel === 'facebook'
                    ? ['Posts', 'Profile', 'Likes', 'Comments', 'Shares']
                    : channel === 'twitter'
                      ? ['Posts', 'Profile', 'Likes', 'Replies', 'Views', 'Reposts']
                      : channel === 'instagram' && search_type == 'user'
                        ? ['Posts', 'Likes', 'Comments', 'Views']
                        : channel === 'instagram' && search_type == 'hashtag'
                          ? ['Posts', 'Profile', 'Likes', 'Comments', 'Views']
                          : ['Posts', 'Profile', 'Likes', 'Comments']
            }
            channel={channel}
          />
        )}
      </Wrapper>
    </ContainerWrapper>
  );
}

export default ReviewsTab;
